"use strict";
IREP.Challenge = (function () {


    function init(start) {

        //timer();

        $(".startChallenge").on("click", function () {
            IREP.callApi({
                url: "quiz",
                type: "GET",
                data: {
                    activityCode: "201703_LARChallenge"
                }
            }).done(function (d) {
                var options = $.extend({}, d, { allowReview: false, timeDivisor: 1, apiRoot: IREP.options.apiUrl, quizSelector: '#contentContainer, #footer, #header', quizBodyClass: "videoquiz", redirectId: 14 })
                IREP.quiz = new IREP.Quiz(options);
                IREP.quiz.startQuiz();

                $(IREP.quiz).on("irep.quiz.results", function (e, result) {
                    window.location.href = window.location.href

                });
            });
        });

        $('.Challengebtn').on('click', function () {
            $(this).hide();
        });

        if (start === true) {
            IREP.callApi({
                url: "quiz",
                type: "GET",
                data: {
                    activityCode: "201703_LARChallenge"
                }
            }).done(function (d) {
                var options = $.extend({}, d, { allowReview: false, timeDivisor: 1, apiRoot: IREP.options.apiUrl, quizSelector: '#contentContainer, #footer, #header', quizBodyClass: "videoquiz", redirectId: 14 })
                IREP.quiz = new IREP.Quiz(options);
                IREP.quiz.startQuiz();

                $(IREP.quiz).on("irep.quiz.results", function (e, result) {
                    window.location.href = window.location.href

                });
            });
        }


    }

    function timer() {

            //var pageLoadDateTime = new Date(startTimer.pageLoadDateTime);

            IREP.callApi("/activity/challengeStartDate", "GET").done(function (data) {
                
                var dates = new Date();
                var pageLoadedLocalDateTime = data.startDate;

                var getTimes = function () {

                    var diff = (pageLoadedLocalDateTime.getTime() - dates.getTime()) / 1000;
                    var timeElapsed = getElapsedTime();
                    diff = diff - timeElapsed;

                    diff = Math.abs(Math.floor(diff));

                    var days = Math.floor(diff / (24 * 60 * 60));
                    var seconds = diff - days * 24 * 60 * 60;

                    var hours = Math.floor(seconds / (60 * 60));
                    seconds = seconds - hours * 60 * 60;

                    var minutes = Math.floor(seconds / (60));
                    seconds = seconds - minutes * 60;

                    updateChallengeCountdownTimer(days, hours, minutes);
                };

                var challengeCountdownTimer = setInterval(function () { getTimes() }, 1000); 


                var getElapsedTime = function () {
                    var currentDateTime = new Date();
                    return (currentDateTime - pageLoadedLocalDateTime) / 1000;
                }

                var updateChallengeCountdownTimer = function (days, hours, minutes) {
                    console.log(days + ' ' + hours + ' ' + minutes);
                    $("#challengeCountdownText").text($('#challengeCountdownText').text().replace("{0}", days).replace("{1}", hours).replace("{2}", minutes));
                    $("#challengeCountdownText").css("display", "block");
                }
            })
   
        
    }
        return {
            init: init,
            timer: timer
        };
    
})();



////IREP.Challenge.timer = (function () {

////    //function timer(startTimer) {
////    //IREP.callApi("/activity/challengeStartDate", "GET", params).done(function (data) {

////    //});
////        var challengeStartDate, pageLoadedDateTime, pageLoadedLocalDateTime;
////        var init = function (initOptions) {
////            challengeStartDate = new Date(initOptions.challengeStartDate);
////            pageLoadedDateTime = new Date(initOptions.pageLoadedDateTime);
////            pageLoadedLocalDateTime = new Date();

////            //ShowNextChallengeCountdown();

////            if (challengeStartDate > pageLoadedLocalDateTime) {
////                timer();
////            }

////            //};

////            function timer() {



////                var timeToNextChallenge;
////                var ShowNextChallengeCountdown = function () {
////                    var d = new Date();
////                    var d2 = new Date(challengeStartDate);

////                    timeToNextChallenge = Math.abs(d2 - d);

////                    var timer1 = new IREP.Countdown({ totalTime: timeToNextChallenge, updateTime: 1000 });
////                    timer1.start(handleNextPlayProgress).progress(handleNextPlayRanOut).done(handleNextPlayStopped).fail();
////                }


////                //var ShowNextChallengeCountdown = function () {

////                //    getTime();
////                //    var nextChallengeCountdown = setInterval(function () { getTime() }, 60000);
////                //}

////                //var getTime = function () {

////                //    var diff = (challengeStartDate - pageLoadedDateTime) / 1000;
////                //    var timeElapsed = getElapsedTime();
////                //    diff = diff - timeElapsed;
////                //    //if (diff < 0) {
////                //    //    clearInterval(nextChallengeCountdown);
////                //    //    $(".promotionCountdown").css("display", "none");
////                //    //}
////                //    diff = Math.abs(Math.floor(diff));

////                //    var days = Math.floor(diff / (24 * 60 * 60));
////                //    var seconds = diff - days * 24 * 60 * 60;

////                //    var hours = Math.floor(seconds / (60 * 60));
////                //    seconds = seconds - hours * 60 * 60;

////                //    var minutes = Math.floor(seconds / (60));
////                //    seconds = seconds - minutes * 60;

////                var handleNextChallengeProgress = function (args) {
////                    var duration = timeToNextChallenge - args.elapsed;
////                    var seconds = parseInt((duration / 1000) % 60)
////                    , minutes = parseInt((duration / (1000 * 60)) % 60)
////                    , hours = parseInt((duration / (1000 * 60 * 60)) % 24)
////                    , days = parseInt((duration / (1000 * 60 * 60 * 24)));

////                    days = ((days < 10) ? "0" + days : days).toString();
////                    hours = ((hours < 10) ? "0" + hours : hours).toString();
////                    minutes = ((minutes < 10) ? "0" + minutes : minutes).toString();
////                    seconds = ((seconds < 10) ? "0" + seconds : seconds).toString();

////                        updateChallengeCountdownTimer(days, hours, minutes, seconds);
////                    };

////                    //var getElapsedTime = function () {
////                    //    var currentDateTime = new Date();
////                    //    return (currentDateTime - pageLoadedLocalDateTime) / 1000;
////                    //}

////                    var updateChallengeCountdownTimer = function (days, hours, minutes, seconds) {
////                        $("#nextPlayTimer").find(".days").find(".left").html(days[0]);
////                        $("#nextPlayTimer").find(".days").find(".right").html(days[1]);
////                        $("#nextPlayTimer").find(".hours").find(".left").html(hours[0]);
////                        $("#nextPlayTimer").find(".hours").find(".right").html(hours[1]);
////                        $("#nextPlayTimer").find(".minutes").find(".left").html(minutes[0]);
////                        $("#nextPlayTimer").find(".minutes").find(".right").html(minutes[1]);
////                        $("#nextPlayTimer").find(".seconds").find(".left").html(seconds[0]);
////                        $("#nextPlayTimer").find(".seconds").find(".right").html(seconds[1]);
////                    }
////                    var handleNextPlayRanOut = function (args) {
////                        window.location.reload();
////                    };

////                    var handleNextPlayStopped = function (args, customArgs) {
////                        window.location.reload();
////                    };
////                }
////            };
       
////    return {
////        init: init
////    };

////})();

